import Slider from '../slider';

export default (element, data) => {
  const elementSlider = element.querySelector('[data-collection-banner-slider]');
  const elementSlides = element.querySelectorAll('[data-collection-banner-slider-slide]');
  if (!elementSlider || elementSlides.length < 3) return;

  const { layout } = data;
  let slider = null; 

  const manageClasses = (action) => {
    const sliderWrapper = element.querySelector('[data-collection-banner-slider-wrapper]');
    if (elementSlider) elementSlider.classList[action]('swiper');
    if (sliderWrapper) sliderWrapper.classList[action]('swiper-wrapper');
    elementSlides.forEach(slide => slide.classList[action]('swiper-slide'));
  };

  const initSlider = () => {
    manageClasses('add');
    slider = new Slider({
      el: elementSlider,
      options: { 
        slidesPerView: 2.5,
        breakpoints: {
          640: {
            slidesPerView: 5,
          }
        }
      },
      
    });
  };

  const sliderCheck = () => {
    if (layout.isAboveBreakpoint('lg')) {
      if (slider) {
        slider.destroy(true, true);
        slider = null;
      }
      manageClasses('remove');
    } else if (!slider) {
      initSlider();
    }
  };

  const debounce = (func, wait, immediate) => {
    let timeout;
  
    return (...args) => {
      const context = this;
  
      const later = () => {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
  
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
  
      if (callNow) {
        func.apply(context, args);
      }
    };
  };
  
  const debouncedCheck = debounce(sliderCheck, 250);
  sliderCheck(); 
  window.addEventListener('resize', debouncedCheck);
};
